import cx from 'classnames';
import { FunctionComponent, ReactNode } from 'react';

const ListHeader: FunctionComponent<{
  as?: keyof JSX.IntrinsicElements;
  children: ReactNode;
}> = ({ as: As = 'div', children, ...props }) => (
  <As
    className={cx(
      'mt-11 first:mt-0',
      'pb-3',
      'lg:flex',
      'w-full',
      'text-[38px] leading-9',
      'font-bold uppercase',
      'select-none',
      'text-bparts-100',
      'max-lg:px-3.5 p-3'
    )}
  >
    {children}
  </As>
);

export default ListHeader;
